module.exports = __webpack_public_path__ + "img/KSC00498-2.4966da27.jpg";